import React from 'react'
import cx from 'classnames'

import { DropdownHandlersContext, DropdownPropsContext } from './../../context'

import styles from './Anchor.module.scss'

type AnchorProps = {
  ariaLabel?: string
  children?: React.ReactNode
  className?: string
  isDisabled?: boolean
}

export const Anchor = ({
  ariaLabel,
  children,
  isDisabled = false,
  className,
}: AnchorProps) => {
  const { onToggle } = React.useContext(DropdownHandlersContext)!
  const { reference } = React.useContext(DropdownPropsContext)!

  return (
    <button
      aria-label={ariaLabel}
      className={cx(styles.anchor, className)}
      ref={reference}
      onClick={onToggle}
      disabled={isDisabled}
    >
      <span className={styles.content}>{children}</span>
    </button>
  )
}
